<template>
	<div style="overflow: hidden;">
		<div class="news-title">
			<i class="iconfont iconanchor-full"></i>
			<div style="margin: 0 20px;">
				中国人民解放军海军博物馆文物征集捐赠证书
			</div>
			<i class="iconfont iconanchor-full"></i>
		</div>
		<div class="topic-main">
			<div class="topic-block">
				<div class="topic-box" v-for="(item, index) in topicList" :key="index" @click="openImg(item.listImgPc)">
					<div class="topic-image">
						<img :src="$imgUrl + item.listImgPc" alt="">
					</div>
				</div>
			</div>
			<page :pageObj="params" @getDataList="getTopicList"></page>
		</div>
		<div class="mask" v-if="showImg">
			<div class="image-main">
				<div class="close" @click="close">
					×
				</div>
				<img :src="$imgUrl + showImgUrl" >
			</div>

		</div>
	</div>
</template>

<script>
	import Page from '@/components/Page.vue'
	export default {
		name: '',
		components: {
			Page,
		},
		data () {
			return {
				params: {
					current: 1,
					size: 12,
					channelId: this.$store.state.channelId,
					releaseTerrace: "releasePc"
				},
				topicList: [],
				showImg: false,
				showImgUrl: ""
			}
		},
		mounted() {
			let that = this
			that.$store.state.showTopImage = true
			that.$store.state.topImage = '../../static/top_banner_5.png'
		},
		methods: {
			getTopicList(dataList) {
				document.body.scrollTop = document.documentElement.scrollTop = 0
				this.topicList = dataList
				console.log(this.topicList);
			},
			openImg(url) {
				this.showImgUrl = url
				this.showImg = true
			},
			close() {
				this.showImg = false
			}
		}
	}
</script>

<style lang="less" scoped>
	.news-title {
		display: flex;
		height: 80px;
		line-height: 80px;
		font-size: 18px;
		color: #922627;
		text-align: center;
		justify-content: center;
		border-bottom: 3px solid #EDD68E;
		width: 1000px;
		margin: 10px auto;
		i {
			font-size: 17px;
			color: #F8C822;
		}
	}
	.top-image {
		width: 100%;
		height: 260px;
		img {
			width: 100%;
			height: 100%;
		}
	}
	.topic-main {
		width: 100%;
		padding: 25px 13%;
		.topic-block {
			width: 100%;
			display: flex;
			flex-wrap: wrap;
			.topic-box {
				width: 32%;
				margin: 5px 0.5%;
				cursor: pointer;
				img {
					width: 100%;
				}
			}
		}
	}
	.mask{
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.7);
		top: 0;
		left: 0;
		position: fixed;
		z-index: 998;
		.image-main {
			margin: 5% auto 0;
			width: 60%;
			height: 70%;
			z-index: 999;
			.close {
				height: 70px;
				width: 100%;
				color: #FFFFFF;
				text-align: right;
				font-size: 60px;
				cursor: pointer;
			}
			img {
				width: 100%;
				height: calc(100% - 70px);
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/wwzj/jzzs.vue